<div class="video-container" #playerVideoContainer>
  <div class="timer">
    <app-timer-v2 [countdown]="countdown" *ngIf="countdown > 0"></app-timer-v2>
  </div>
  <div #dealerVideo class="paused-container" *ngIf="mode === modeType.Paused; else streamSection">
    <h2>GAME PAUSED</h2>
  </div>
  <ng-template #streamSection>
    <div id="classicDealerVideo" [attr.attr-stream-name]="streamName"></div>
  </ng-template>
</div>
